<template>
  <main class="content-page">
    <v-container
      fluid
      class="outer-container"
    >
      <v-row>
        <v-col>
          <!-- <h1 class="content text-center">404 Page not found</h1> -->
          <Error404 />
        </v-col>
      </v-row>
    </v-container>
    <foot />
  </main>
</template>

<script setup>
  import { onMounted } from "vue";
  import Error404 from "@/components/404.vue";
  import router from "@/router";

  import { useHead } from "@unhead/vue";
  import Foot from "@/components/Foot.vue";

  useHead({
    title: "Digital Frontier | 404",
  });

  onMounted(() => {
    window.scrollTo(0, 0);
  });
</script>

<style scoped lang="scss">
  .outer-container {
    min-height: 20vh;
  }
</style>
